// Shinhan Design System 2024 color tokens (JS export).
// Mirror of src/scss/_tokens.scss for use in inline styles and SVG fills.
// Source: Shinhan Figma — Material 3 color roles.

export const ShinhanColors = {
  // PRIMARY
  primary: "#005DF9",
  onPrimary: "#FFFFFF",
  onPrimaryContainer: "#0040E8",
  primaryFixed: "#CCDAFF",
  onPrimaryFixed: "#001C66",
  primaryFixedDim: "#B3C8FF",
  onPrimaryFixedVariant: "#0040E8",
  surfaceTint: "#005DF9",

  // SURFACE & TEXT
  surface: "#FFFFFF",
  surfaceContainerLowest: "#F3F6FB",
  surfaceContainerLow: "#F2F2F2",
  surfaceContainer: "#EBEFF5",
  surfaceContainerHigh: "#E8E8E8",
  surfaceContainerHighest: "#D6DBE1",
  surfaceVariant: "#D6DBE1",
  onSurface: "#121418",
  onSurfaceVariant: "#6C747E",

  // OUTLINE
  outline: "#E1E3E9",
  outlineVariant: "#E5E7ED",

  // SECONDARY (Green)
  secondary: "#00AC5A",
  onSecondary: "#FFFFFF",
  secondaryContainer: "#B6FFD3",
  onSecondaryContainer: "#006C40",

  // TERTIARY (Orange)
  tertiary: "#FCA425",
  onTertiary: "#FFFFFF",
  tertiaryContainer: "#FFD8A0",
  onTertiaryContainer: "#5E3A00",

  // ERROR (Red)
  error: "#D61111",
  onError: "#FFFFFF",
  errorContainer: "#FFDAD6",
  onErrorContainer: "#8C0000",

  // INVERSE
  inverseSurface: "#24272D",
  inverseOnSurface: "#E1E6EC",
  inversePrimary: "#B3C8FF",

  // CUSTOM
  warning: "#FB8C00",
  warningContainer: "#FFF4E5",
  success: "#2E7D32",
  successContainer: "#E8F5E9",
  urgent: "#E53935",
  tagPurple: "#9C27B0",
  tagPink: "#E91E63",
  tagLavender: "#D7E8FF",
};

export default ShinhanColors;
